module.exports = __webpack_public_path__ + "static/media/heimerl_brand_clean.102e69ae.svg";